<template>
  <el-drawer
    custom-class="el-drawer-deal el-drawer-credit"
    :visible.sync="ifshow"
    size="840px"
    v-if="ifshow"
    class="el_drawerInfo"
  >
    <div slot="title">
      <dealTitle :data="getByIdFullData" assignLoginType="HCM" otherType="myReport"></dealTitle>
    </div>
    <div>
      <!-- 举报信息 -->
      <commonReportInfo></commonReportInfo>
      <!-- 响应信息 -->
      <div v-if="getByIdFullData.type != 2">
        <div v-for="item in getByIdFullData.flowList" :key="'a'+item.createtime">
          <!-- 未响应 -->
          <div v-if="item.status==6&&item.lable">
            <div class="drawer-subtitle_common">
              <span>{{item.lable}}</span>
            </div>
            <el-card class="margin_bottom20">
              <el-form :label-width="labelWidth">
                <el-form-item label="响应方式：">未响应</el-form-item>
              </el-form>
            </el-card>
          </div>
          <!-- 申诉评定信息 -->
          <div v-if="item.status==13">
            <div class="drawer-subtitle_common">
              <span>申诉评定信息</span>
            </div>
            <el-card class="margin_top_bottom20">
              <el-form :label-width="labelWidth">
                <el-form-item label="申诉评定：">申诉不合理</el-form-item>
                <el-form-item label="评定说明：">{{item.reportexplain}}</el-form-item>
              </el-form>
            </el-card>
          </div>
          <!-- 店铺已整改-待复查 -->
          <div v-if="item.status==2&&item.lable">
            <div class="drawer-subtitle_common">
              <span>{{item.lable}}</span>
            </div>
            <el-card class="margin_top_bottom20">
              <el-form :label-width="labelWidth">
                <el-form-item label="响应方式：">{{item.resulttype}}</el-form-item>
              </el-form>
            </el-card>
          </div>
          <!-- 店铺整改合格-待处理||店铺已申诉-待处理 -->
          <div v-if="(item.status==3||item.status==4||item.status==5||item.status==8)&&item.lable">
            <div class="drawer-subtitle_common">
              <span>{{item.lable}}</span>
            </div>
            <el-card class="margin_top_bottom20">
              <el-form :label-width="labelWidth">
                <el-form-item
                  v-if="item.state!==8"
                  :label="item.status==5?'响应方式：':'复查结果：'"
                >{{item.status==3?'店铺整改合格':item.status==4?'店铺整改不合格':'店铺已申诉'}}</el-form-item>
                <el-form-item :label="item.status==5?'申诉截图：':item.status==8?'二次申诉截图：':'复查截图：'">
                  <viewer :images="item.reportpic" v-if="item.reportpic">
                    <img
                      v-for="(item,index) in item.reportpic"
                      :src="item"
                      alt
                      :key="index"
                      style="width:100px;height:100px"
                    />
                  </viewer>
                </el-form-item>
                <el-form-item
                  :label="item.status==5?'申诉理由：':item.status==8?'二次申诉理由：':'复查说明：'"
                >{{item.reportexplain}}</el-form-item>
              </el-form>
            </el-card>
          </div>

          <div v-if="item.status==10&&getByIdFullData.status==10">
            <el-row class="info_header">
              <el-col :span="12">
                <div class="drawer-subtitle_common">
                  <span class="drawer-subtitle-text">初审信息</span>
                </div>
              </el-col>
              <el-col :span="10" style="text-align:right">
                <el-link type="primary" :underline="false" @click="fastReport">快速重新举报</el-link>
              </el-col>
            </el-row>
            <el-card class="margin_top_bottom20">
              <el-form :label-width="labelWidth">
                <el-form-item label="初审结果：">驳回举报</el-form-item>
                <el-form-item label="驳回说明：">{{item.reportexplain}}</el-form-item>
                <el-form-item label="初审人：">{{item.flowusername}}</el-form-item>
                <el-form-item label="初审时间：">{{item.flowtime |fullTime}}</el-form-item>
              </el-form>
            </el-card>
          </div>
        </div>

        <!-- 申诉评定信息 -->
        <div v-if="ifEvaluate">
          <div class="drawer-subtitle_common">
            <span>申诉评定信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="申诉评定：">申诉合理</el-form-item>
              <el-form-item label="评定说明：">{{getByIdFullData.reportexplain}}</el-form-item>
            </el-form>
          </el-card>
        </div>
        <!-- 处理结果 -->
        <div v-if="(getByIdFullData.status==7||getByIdFullData.status==9)">
          <div class="drawer-subtitle_common">
            <span>结果信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="结果说明：">
                <span>{{getByIdFullData.result}}</span>
              </el-form-item>
              <!-- <el-form-item label="处理说明：">
                <span>{{getByIdFullData.decisions}}</span>
              </el-form-item> -->
            </el-form>
          </el-card>
        </div>
        <!-- 积分处理信息 -->
        <div v-if="getByIdFullData.points||getByIdFullData.points===0">
          <div class="drawer-subtitle_common">
            <span>积分处理信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="扣分值：">
                <span>{{getByIdFullData.points}}</span>
              </el-form-item>
              <el-form-item label="附加处罚：">
                <span>{{getByIdFullData.punish}}</span>
              </el-form-item>
              <el-form-item label="扣分说明：">
                <span>{{getByIdFullData.pointsexplains}}</span>
              </el-form-item>
            </el-form>
          </el-card>
        </div>

        <!-- 已处理 -->
        <div v-if="getByIdFullData.status==12">
          <div class="drawer-subtitle_common">
            <span>处理信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="处理方式：">{{getByIdFullData.result}}</el-form-item>
              <el-form-item label="处理截图：">
                <viewer :images="getByIdFullData.handlepic">
                  <img
                    v-for="(item,index) in getByIdFullData.handlepic"
                    :src="item"
                    alt
                    :key="index"
                    style="width:100px;height:100px"
                  />
                </viewer>
              </el-form-item>
              <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
      <div v-if="getByIdFullData.type == 2 && getByIdFullData.result">
        <div class="drawer-subtitle_common">
          <span>处理信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="处理方式：">{{getByIdFullData.result}}</el-form-item>
            <el-form-item label="处理截图：">
              <viewer :images="getByIdFullData.handlepic">
                <img
                  v-for="(item,index) in getByIdFullData.handlepic"
                  :src="item"
                  alt
                  :key="index"
                  style="width:100px;height:100px"
                />
              </viewer>
            </el-form-item>
            <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import dealTitle from "@/views/CreditScore/common/dealMainInfo/dealTitle";
import { ifEvaluate} from "@/libs";

export default {
  data() {
    return {
      ifshow: false,
      labelWidth: "130px",
    };
  },
  components: { commonReportInfo, dealTitle },
  computed: {
    ifEvaluate() {
      return ifEvaluate(this.getByIdFullData.flowList)
    },
    ...mapGetters(["getByIdFullData"]),
  },
  methods: {
    fastReport() {
      let Logistics = this.$router.resolve({
        path: "/CreditScoreOutInform",
        query: this.getByIdFullData,
      });
      window.open(Logistics.href, "_blank");
    },
  },
};
</script>
<style lang="scss">
.el_drawerInfo {
  .el-drawer__header {
    // margin-bottom: 0px !important;
  }
  .el-drawer__body {
    padding: 0 20px 20px 20px !important;
  }
  form {
    display: block !important;
  }
}
</style>
